export default "__VITE_ASSET__C2nQW71v__"